<template>
    <div>
        <nav id="sidebar" v-if="(desktop || largeDesktop) && rail" class="d-flex">
            <div>
                <b-list-group>
                    <b-list-group-item button class="logo-header" @click="rail = !rail">
                        <div class="d-flex">
                            <img class="mr-3 logo" src="../assets/logo.svg" />
                            <h2 class="ml-1">ИМС Нова</h2>
                        </div>
                        <div>
                            <i class="fas fa-chevron-left mr-2"></i>
                        </div>
                    </b-list-group-item>
                </b-list-group>
                <b-list-group class="mt-2" role="tablist"  v-for="(menu, index) in targetMenu" :key="index">
                    <b-list-group-item class="menu-list-item py-3 px-1"
                                       v-b-toggle="'accordion-'+index"
                                       role="tab"
                                       button
                                       >
                        <div class="d-flex justify-content-between">
                          <div class="d-flex">
                              <i :class="menu.icon" class="ml-3" style="font-size: x-large;"></i>
                              <span class="ml-5" style="color: #000;">{{ menu.caption }}</span>
                          </div>
                          <div>
                              <i class="fas fa-chevron-down mr-2"></i>
                              <i class="fas fa-chevron-up mr-2"></i>
                          </div>
                        </div>
                    </b-list-group-item>
                    <b-collapse :id="'accordion-'+index" :accordion="'accordion'+index" role="tabpanel" visible>
                        <b-list-group-item :to="legacy.link"
                                         class="list-opened-group-item"
                                         style="color: #000; padding-left: 50px;"
                                         :active="legacy.link === $route.path"
                                         v-for="(legacy, ind) in menu.children"
                                         :key="ind">
                        {{legacy.caption}}
                        </b-list-group-item>
                    </b-collapse>
                </b-list-group>
            </div>
            <div>
                <b-list-group-item button class="logo-header justify-content-end" @click="rail = !rail">
                    <div>
                        <i class="fas fa-chevron-left mr-2"></i>
                    </div>
                </b-list-group-item>
            </div>
        </nav>
        <nav class="sidebar-hidden" v-if="(desktop || largeDesktop) && !rail">
            <div>
                <b-list-group>
                    <b-list-group-item button class="logo-header" @click="rail = !rail">
                        <div class="d-flex">
                            <img class="mr-3 logo" src="../assets/logo.svg" />
                        </div>
                    </b-list-group-item>
                </b-list-group>
                <b-list-group class="mt-2">
                    <b-list-group-item class="menu-list-item py-3 px-1 d-flex justify-content-center"
                                       v-for="(menu, index) in targetMenu"
                                       button
                                       :active="activeMenuCaption(menu.children)"
                                       :key="index">
                        <b-dropdown v-if="menu.children && menu.children.length"
                                    toggle-class="text-decoration-none button-menu-item"
                                    dropright
                                    size="lg"
                                    no-caret>
                            <template #button-content>
                                <i :class="menu.icon" style="font-size: x-large;" :style="activeMenuCaption(menu.children) ? { color: '#0284c7' } : {}"></i>
                            </template>
                            <b-dropdown-header>{{ menu.caption }}</b-dropdown-header>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item :to="legacy.link"
                                             :active="legacy.link === $route.path"
                                             v-for="(legacy, ind) in menu.children"
                                             :key="ind">
                                {{legacy.caption}}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-list-group-item>
                </b-list-group>
            </div>
            <div>
                <b-list-group-item button class="logo-header justify-content-center" @click="rail = !rail">
                    <div>
                        <i class="fas fa-chevron-right"></i>
                    </div>
                </b-list-group-item>
            </div>
        </nav>
        <b-sidebar v-if="mobile || tablet" v-model="sidebar_model" id="sidebar-mobile" :width="tablet ? '50%' : ''" shadow>
            <template v-slot:title>
                <div class="d-flex flex-nowrap align-items-center justify-content-between">
                    <img class="mr-3" src="../assets/logo.svg"/>
                    <span class="mr-1">ИМС Нова</span>
                    <div class="mr-1">
                        <span>|</span>
                    </div>
                    <span>Личный кабинет</span>
                </div>
            </template>
            <div>
                <ul class="cd-accordion-menu">
                    <item
                          :key="index"
                          v-for="(menu, index) in targetMenu"
                          :menu="menu"></item>
                </ul>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import Item from './Item'
import menu from './menu.js'
import { mapState } from 'vuex'

export default {
  name: 'left-sidebar',
  data () {
    return {
      version: null,
      targetMenu: [],
      userMenu: menu.userMenu,
      rail: true,
      sidebar_model: true
    }
  },
  components: {
    Item
  },
  mounted () {
    if (this.$route.meta.title === 'user') {
      this.prepareMenu(this.userInfo, 'user')
    }
    if (this.$route.name === 'main-container') {
      let menuIndex
      const userMenuChildren = this.userMenu.reduce((prev, next) => prev.concat(next.children), [])
      for (let i = 0; i < this.userInfo.rights.length; i++) {
        if (this.userInfo.rights.includes('organisations-users')) i = this.userInfo.rights.indexOf('organisations-users')
        menuIndex = this.userMenu.find(e => e.name === this.userInfo.rights[i])?.name
        if (!menuIndex) {
          menuIndex = userMenuChildren.find(e => e.name === this.userInfo.rights[i])?.link
        }
        if (menuIndex) {
          this.$router.push(menuIndex)
          break
        }
      }
    }

    this.rail = (localStorage.getItem('sidebarPosition') !== 'false')
  },
  computed: {
    ...mapState(
      {
        userInfo: state => state.authorization.userInfo,
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop
      }
    )
  },
  methods: {
    activeMenuCaption (items) {
      return items.some(item => item.link === this.$route.path)
    },
    prepareMenu (items, target) {
      let rights = (target === 'user' ? items.rights : [])
      rights = [...rights].sort()
      const menuList = (target === 'user' ? this.userMenu : [])
      const tree = []
      for (let i = 0; i < rights.length; i++) {
        const name = rights[i]
        const dataTraverse = (currentMenuList, parent) => {
          currentMenuList.forEach(function (item) {
            if (item.name === name && item.parent_id === null) {
              tree.push(item)
            }
            if (item.name === name && item.parent_id !== null) {
              const treeItem = tree.filter(index => index.name === parent.name)
              if (treeItem.length === 0) {
                const newItem = Object.assign({}, parent)
                newItem.children = []
                newItem.children.push(item)
                tree.push(newItem)
              } else {
                const treeItemAlreadyHasItem = treeItem[0].children.filter(index => index.name === item.name)
                if (treeItemAlreadyHasItem.length === 0) {
                  if (treeItem[0].id === 20) treeItem[0].children.unshift(item)
                  else treeItem[0].children.push(item)
                }
              }
            }
            if (item.children && item.children.length > 0) {
              dataTraverse(item.children.slice(), item)
            }
          })
        }
        dataTraverse(menuList, null)
      }
      this.sortMenuInRightsOrder(menuList, tree)
    },
    sortMenuInRightsOrder (menuList, tree) {
      this.targetMenu = []
      const rightsInOrder = []
      menuList.forEach((item) => {
        rightsInOrder.push(item.name)
      })
      for (let i = 0; i < rightsInOrder.length; i++) {
        for (let j = 0; j < tree.length; j++) {
          if (rightsInOrder[i] === tree[j].name) {
            this.targetMenu.push(tree[j])
          }
        }
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.meta.title === 'user') {
        this.prepareMenu(this.userInfo, 'user')
      }
    },
    rail (val) {
      localStorage.setItem('sidebarPosition', val)
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
    padding-left: 0px;
    line-height: 1.5em;
    list-style-type: none;
    margin: 0;
}

.version {
    color: #90a4ae;
    margin-left: 50px;
    font-size: 12px;
    margin-bottom: 0;
}

#sidebar {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    height: 100vh;
    flex-grow: 1;
    background: #f5f4f4;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

@media screen
and (min-width: 1024px)
and (max-width: 1439px) {
    #sidebar {
        min-width: 215px;
        width: 215px;
        max-width: 215px;
    }
}

@media screen
and (min-width: 1440px) {
    #sidebar {
        min-width: 315px;
        width: 315px;
        max-width: 315px;
    }
}

.logo-header {
    display: flex;
    justify-content: space-between;
    align-items:center;
    background-color: #f5f4f4;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 15px;
    border-bottom: 1px solid rgba(51, 66, 72, 0.125);
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    border-radius: 0px;
    &:focus {
        outline: none !important;
    }
    & h2 {
            font-family: "PT Root UI Bold", Tahoma, Geneva, Verdana, sans-serif;
            margin-bottom: 0;
            color: #37474F;
            font-size: 1.425rem;
            font-weight: 500;
            line-height: 28px;
   }
   .logo {
            margin: 0 10px;
            margin-right: 18px;
            width: 24px;
            height: 24px;
   }
}

.sidebar-hidden {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    height: 100vh;
    flex-grow: 1;
    background: #f5f4f4;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 56px;
    width: 56px;
    max-width: 56px;
}
.menu-list-item.active {
    background: #DAE2ED;
    border: 0px;
}
.menu-list-item {
    background: #f5f4f4;
    border: 0px;
}
.list-opened-group-item {
    background: none;
    border: 0px;
}
.list-opened-group-item.active {
    background: #DAE2ED;
    border: 0px;
    color: rgb(2, 132, 199) !important;
}

</style>
